import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/** Tamaño A4 en puntos (aprox.) */
const A4_ANCHO = 595;
const A4_ALTO = 842;

/**
 * Convierte un archivo de imagen (foto) en un Blob PDF de una página
 * con la imagen ajustada al tamaño de la hoja.
 */
export function imagenFileAPdf(file: File): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      if (!dataUrl || typeof dataUrl !== "string") {
        reject(new Error("No se pudo leer la imagen"));
        return;
      }
      const docDefinition: TDocumentDefinitions = {
        pageSize: "A4",
        pageMargins: [20, 20, 20, 20],
        content: [
          {
            image: dataUrl,
            fit: [A4_ANCHO - 40, A4_ALTO - 40],
            alignment: "center",
          },
        ],
      };
      const pdfDoc = pdfMake.createPdf(docDefinition);
      pdfDoc.getBlob((blob: Blob) => {
        resolve(blob);
      }, {});
    };
    reader.onerror = () => reject(reader.error || new Error("Error leyendo la imagen"));
    reader.readAsDataURL(file);
  });
}
